import { render } from "./empleados.vue?vue&type=template&id=061e85d4&scoped=true"
import script from "./empleados.vue?vue&type=script&lang=js"
export * from "./empleados.vue?vue&type=script&lang=js"

import "./empleados.vue?vue&type=style&index=0&id=061e85d4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-061e85d4"]])

export default __exports__